import { LoaderComp } from "../../components/LoaderComp";

export default function LoaderPage() {
  return <LoaderComp />;
}
